import React from 'react'
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { FeatureFlagProvider } from './contexts/FeatureFlagContext'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import AdminLayout from './components/AdminLayout'
import Login from './pages/Login'
import PlatformConfiguration from './pages/admin/PlatformConfiguration'
import PlatformTenants from './pages/admin/PlatformTenants'
import MobileDeviceApprovals from './pages/admin/MobileDeviceApprovals'
import TenantPrinters from './pages/admin/TenantPrinters'
import StorageMonitoring from './pages/admin/StorageMonitoring'
import BillableUsage from './pages/admin/BillableUsage'
import TenantPsgGateway from './pages/admin/TenantPsgGateway'
import TenantWorkspace from './pages/admin/tenant/TenantWorkspace'
import PendingTenantSetups from './pages/admin/PendingTenantSetups'
import NewTenantSetupWizard from './pages/admin/NewTenantSetupWizard'

export default function App() {
  return (
    <BrowserRouter>
      <FeatureFlagProvider>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <Navigate to="/admin/platform-config" replace />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/platform-config"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <PlatformConfiguration />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tenants"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <PlatformTenants />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tenants/:groupId"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <TenantWorkspace />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tenants/:groupId/:tab"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <TenantWorkspace />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/mobile-devices"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <MobileDeviceApprovals />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/psg-gateway"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <TenantPsgGateway />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/tenant-printers"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <Navigate to="/admin/tenants" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/storage"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <StorageMonitoring />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/billable-usage"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <BillableUsage />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pending-tenant-setups"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <PendingTenantSetups />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/new-tenant-setup/:setupId"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <AdminLayout>
                    <NewTenantSetupWizard />
                  </AdminLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="*"
              element={
                <ProtectedRoute requiredPermission="platform:manage">
                  <Navigate to="/admin/platform-config" replace />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" />
        </AuthProvider>
      </FeatureFlagProvider>
    </BrowserRouter>
  )
}
